import { render, staticRenderFns } from "./PricingFaqAndContactSection.vue?vue&type=template&id=1031af4a&scoped=true&"
import script from "./PricingFaqAndContactSection.vue?vue&type=script&lang=js&"
export * from "./PricingFaqAndContactSection.vue?vue&type=script&lang=js&"
import style0 from "./PricingFaqAndContactSection.vue?vue&type=style&index=0&id=1031af4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031af4a",
  null
  
)

export default component.exports